import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components';
import { rgba } from 'polished';
import Slider from "react-slick";

import { Save } from '../'

import { media } from '../../styles/utils';
import { green, greenSecondary, cream } from '../../styles/colors';
import { hoverState, padding, bgImage } from '../../styles/global';

class ImageReferenceSlideshow extends Component {

    state = {
        totalSlides: this.props.images ? this.props.images.length : 0,
        activeSlide: 1,
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.activeSlide !== this.props.activeSlide) {
            this.setState({
                activeSlide: this.props.activeSlide
            })

            this.slider.slickGoTo(this.props.activeSlide, true)
        }
    }  

    updateActiveSlide = (oldIndex, newIndex) => {
        const { updateActiveSlide } = this.props;

        this.setState({
            activeSlide: (newIndex + 1)
        })
    }

    renderSlideCounter = () => {
        const { totalSlides, activeSlide } = this.state;

        return (
            <SlideCounter>
                {`${activeSlide}/${totalSlides}`}
            </SlideCounter>
        )
    }

    onClick = (type) => {
        if (type == 'right') {
            this.slider.slickNext()
        }

        if (type == 'left') {
            this.slider.slickPrev()
        }
    }

    renderSlides = () => {
        const { images, tags, caption, imageReference } = this.props;

        if (images) {
            
            const slides = images.map((slide, i) => {

                //console.log(slide)

                // Tags

                let tagsArray = slide.tags;

                if (tags) {
                    tagsArray = tags;
                }

                // Caption

                let imageCaption = slide && slide.image && slide.image.caption;
                
                return (
                    <Slide key={i}>

                        <SaveWrapper>
                            <Save
                                white={true}
                                type={imageReference ? 'imageReference' : 'image'}
                                id={slide.image ? slide.image.id : slide.id}
                                saveLabel={'Save this image to favourites'}
                                removeLabel={'Remove this image from favourites'}
                            />
                        </SaveWrapper>

                        <ImageWrapper>
                            <Image
                                src={slide.image ? slide.image.sizes.full_width : slide.full}
                            />
                        </ImageWrapper>

                        <ClickDetector
                            type={'right'}
                            onClick={() => this.onClick('right')}
                        />

                        <ClickDetector
                            type={'left'}
                            onClick={() => this.onClick('left')}
                        />
                    
                        <Info>
                            {this.renderSlideCounter()}

                            {imageCaption && (
                                <Caption>{imageCaption}</Caption>
                            )}
                            
                            {tagsArray && (
                                <Tags>
                                    {tagsArray.map((tag, i) => {
                                        return (
                                            <Tag 
                                                key={i}
                                            >
                                                {tag.name}
                                                {i !== (tagsArray.length - 1) && ','}
                                            </Tag>
                                        )
                                    })}
                                </Tags>
                            )}
                            
                        </Info>
                    </Slide>
                )
            })

            return slides
        }
    }
    
    render() {
        const { inModal } = this.props;

        var settings = {
            dots: false,
            infinite: true,
            arrows: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            //useTransform: false
        }

        return (
            <Container
                inModal={inModal}
            >
                <Slider
                    ref={slider => (this.slider = slider)}
                    beforeChange={this.updateActiveSlide}
                    {...settings}
                >
                    {this.renderSlides()}
                </Slider>
            </Container>
        )
    }
}

const Container = styled.div`
    position: relative;

    ${props => {
        if (props.inModal) return css`
            width: 100vw;
            height: 100vh;

            ${ImageWrapper} {
                height: calc(100vh - 36px);

                ${media.phone`
                    height: calc(100vh - 87px);
                    position: relative;

                    ${Image} {
                        width: 100%;
                        height: auto;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                `}
            }
        `
    }}
`

const Slide = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: black;

    &:focus {
        outline: none;
    }

    transform: translate3d(0, 0, 0);
    will-change: transfrom;
`

const ImageWrapper = styled.div`
    flex: 1;
    height: 593px;

    ${media.phone`
        height: 200px;
    `}
`

const Image = styled.img`
    width: auto;
    height: 100%;
    max-height: 100%;
    max-width: 100%;
`

const SaveWrapper = styled.div`
    position: absolute;
    top: 14px;
    left: 18px;
    z-index: 10;
`

const Info = styled.div`
    height: 36px;
    display: flex;
    background: ${cream};
    align-items: center;
    padding: 0 11px 0 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #979797;

    ${media.phone`
        height: 87px;
        align-items: flex-start;    
        padding-top: 8px;
        padding: 8px 10px 0 10px;
    `}
`

const SlideCounter = styled.div`
`

const Caption = styled.div`
    margin-left: 36px;

    ${media.phone`
        margin-left: 18px;
    `}

`

const Tags = styled.div`
    margin-left: auto;
    display: flex;

    ${media.phone`
        position: absolute;
        bottom: 13px;
        left: 49px;
    `}
`

const Tag = styled.div`

    &:not(:last-child) {
        margin-right: 4px;
    }
`

const ClickDetector = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;

    ${props => {
        if (props.type == 'right') return css`
            right: 0;
            left: 50%;
            cursor: e-resize;
        `

          if (props.type == 'left') return css`
            left: 0;
            right: 50%;
            cursor: w-resize;
        `
    }}
`   


export default ImageReferenceSlideshow;


// WEBPACK FOOTER //
// ./client/components/ImageReferenceSlideshow/ImageReferenceSlideshow.js